import React from "react";

export default class Process extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "0"
    };
  }
  componentWillReceiveProps(props) {
    this.setState({
      value: props.value
    });
  }
  handleChange = e => {
    const value = e.target.value;
    this.setState({
      value
    });
    this.props.play(value);
  };
  handeInput = e => {
    console.log("input");
  };
  render() {
    const { value } = this.state;
    return (
      <div className="ssy-process">
        <input
          style={{ backgroundSize: `${value}% 100%` }}
          type="range"
          value={this.state.value}
          onInput={this.handeInput}
          onChange={this.handleChange}
          id="range"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/getVipBySign/Process.jsx